export class ApiError extends Error {
  status: number;
  body?: any;
  url?: string;

  constructor(status: number, message: string, body?: any, url?: string) {
    super(message);
    this.status = status;
    this.body = body;
    this.url = url;

    Object.setPrototypeOf(this, new.target.prototype);
  }

  isBadRequest(): boolean {
    return this.status === 400;
  }

  isUnauthorized() {
    return this.status === 401;
  }

  isForbidden() {
    return this.status === 403;
  }

  isNotFound() {
    return this.status === 404;
  }

  isValidation() {
    return this.status === 422;
  }

  isServerError() {
    return this.status >= 500;
  }
}